const RECAPTHCA_URL = 'https://www.google.com/recaptcha/api.js';

let FORM = undefined;
let SITE_KEY = '';

export const loadScript = () => {
  const script = document.createElement('script');
  script.setAttribute('async', '');
  script.setAttribute('defer', '');
  script.id = 'recaptchaScript';
  script.src = `${RECAPTHCA_URL}?render=${SITE_KEY}`;
  document.getElementsByTagName('head')[0].appendChild(script);
  FORM.removeEventListener('input', loadScript);
};

export const generateToken = () => {
  window.grecaptcha.ready(function() {
    window.grecaptcha.execute(SITE_KEY, { action: 'submit' }).then(function(token) {
      let tokenElement = document.querySelector('input.recaptcha-token');
      if (tokenElement) {
        tokenElement.value = token;
        tokenElement.dispatchEvent(new CustomEvent('change'));
      }
    });
  });
};

export const handleRecaptcha = (event) => {
  if (!FORM.checkValidity()) {
    return true;
  }
  const submitButton = document.querySelector('input[type=submit]');
  const submitParent = submitButton.parentElement;
  submitParent.removeEventListener('click', handleRecaptcha);
  event.preventDefault();
  const tokenInput = document.querySelector('input.recaptcha-token');
  tokenInput.addEventListener('change', () => {
    submitButton.click();
  });
  generateToken();
};

export const appendRecaptchaClick = () => {
  const submitParent = FORM.querySelector('input[type=submit]').parentElement;
  submitParent.addEventListener('click', handleRecaptcha);
};

export const repositionSitecoreErrorElement = (errorElement) => {
  const newElement = errorElement.cloneNode(true);
  errorElement.remove();
  document.getElementById('recaptcha-error').appendChild(newElement);
};

export const insertedEvent = (event) => {
  const insertedElement = event.target;
  if (insertedElement && insertedElement.tagName !== 'FORM') {
    return;
  }
  FORM = insertedElement;
  appendRecaptchaClick();
  const validationSummary = FORM.querySelector('.validation-summary-errors');
  if (validationSummary && validationSummary.parentElement.id !== 'recaptcha-error') {
    repositionSitecoreErrorElement(validationSummary);
  }
};

export const addNodeInsertedListener = () => {
  document.body.addEventListener('DOMNodeInserted', insertedEvent);
};

export const bindForm = (form) => {
  if (form) {
    FORM = form;
    FORM.addEventListener('input', loadScript);
    appendRecaptchaClick();
    addNodeInsertedListener();
  }
};

export const recaptcha = {
  name: 'recaptcha',
  currentValue: 0,
  inserted(el, binding) {
    SITE_KEY = binding.value.siteKey;
    bindForm(el.closest('form'));
  },
};
